<template>
  <Modal
    v-model="visible"
    :mask-closable="false"
    :footer-hide="true"
    :closable="false"
    width="420"
  >
    <div class="text-content">
      请确认是否暂不处理，如您再次导入系统将不会保存此次异常数据和未存在保单数据
    </div>
    <div class="action-buttom">
      <Button type="primary" @click="confirmHandleData">确认</Button>
      <Button class="cancel" @click="visible = false">取消</Button>
    </div>
  </Modal>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
    };
  },

  methods: {
    open() {
      this.visible = true;
    },

    confirmHandleData() {
      this.visible = false;
      setTimeout(() => {
        this.$emit("confirmHandleData");
      }, 300);
    },
  },
};
</script>

<style lang="scss" scoped>
.text-content {
  padding: 30px 30px;
}

.action-buttom {
  margin-top: 20px;
  padding-bottom: 5px;
  display: flex;
  justify-content: space-between;
  padding: 0px 40px 10px 40px;
  Button {
    width: 140px;
    height: 36px;
  }
  .cancel {
    border-color: #236dff;
    color: #236dff;
  }
}
</style>